import { schema } from "normalizr";
const application = new schema.Entity("applications", undefined, {
  idAttribute: "applicationId"
});
export const applicationsSchema = new schema.Entity("applications", {
  applications: [application]
}, {
  idAttribute: "applicationId"
});